import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Form, Row, Col, FormGroup, Label, Input } from "reactstrap";
import Select from "components/Select";
import { getTheme2SearchFilterColProps } from "utils/theme2MultiSelect";

export const CUSTOMER_ACCOUNT_FILTER_ALL = "all";
export const CUSTOMER_ACCOUNT_FILTER_ACTIVE_FINANCED = "active_financed";

const CustomersFilters = ({
  isTheme2 = false,
  activeColor = "blue",
  selectStyles,
  searchInput,
  onSearchChange,
  accountFilter,
  onAccountFilterChange,
}) => {
  const { t } = useTranslation();
  const filterColProps = getTheme2SearchFilterColProps(isTheme2, {
    filterColClass: "search-customers-filter-col",
    md: "4",
  });

  const accountFilterOptions = useMemo(
    () => [
      { label: t("customers.accountFilterAll"), value: CUSTOMER_ACCOUNT_FILTER_ALL },
      { label: t("customers.accountFilterActiveFinanced"), value: CUSTOMER_ACCOUNT_FILTER_ACTIVE_FINANCED },
    ],
    [t]
  );

  const selectedAccountFilter = useMemo(
    () => accountFilterOptions.find((opt) => opt.value === accountFilter) || accountFilterOptions[0],
    [accountFilterOptions, accountFilter]
  );

  return (
    <Form>
      <Row className={isTheme2 ? "search-customers-filters-row" : "mb-0"}>
        <Col {...filterColProps}>
          <FormGroup>
            <Label>{t("customers.accountFilter")}</Label>
            <Select
              activeColor={activeColor}
              styles={selectStyles}
              className="react-select"
              value={selectedAccountFilter}
              onChange={(option) => onAccountFilterChange(option?.value || CUSTOMER_ACCOUNT_FILTER_ALL)}
              options={accountFilterOptions}
              isSearchable={false}
            />
          </FormGroup>
        </Col>
        <Col {...filterColProps}>
          <FormGroup>
            <Label>{t("customers.searchLabel")}</Label>
            <Input
              type="text"
              placeholder={t("customers.searchPlaceholder")}
              value={searchInput}
              onChange={(e) => onSearchChange(e.target.value)}
              className="form-control"
            />
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};

export default CustomersFilters;
